import React, { FC, memo, ReactNode } from 'react'
import cn from 'classnames'

interface IGridLayoutProps {
  className?: string
  offset?: number
  scrollable?: boolean
  children: ReactNode[]
}

const GridLayout: FC<IGridLayoutProps> = ({
  className,
  scrollable,
  children,
}) => {
  const items = React.Children.toArray(children)

  return (
    <div className={cn('grid-layout', className)}>
      {items.map((child, idx) => (
        <div key={idx}>
          <div
            className={cn('grid-layout_panel', {
              '-scrollable': scrollable,
            })}
          >
            {child}
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(GridLayout)
